import { POLICY_1_CONTENT } from './policy1';
import { POLICY_2_CONTENT } from './policy2';

export interface Policy {
  id: number;
  title: string;
  content: string;
}

export const POLICIES: Record<number, Policy> = {
  1: {
    id: 1,
    title: "이용약관",
    content: POLICY_1_CONTENT,
  },
  2: {
    id: 2,
    title: "개인정보처리방침",
    content: POLICY_2_CONTENT,
  },
  3: {
    id: 3,
    title: "법적고지",
    content: `
<h2>[저작권]</h2>
<p>스마일보건 홈페이지는 브레인다이브가 일체의 비용을 투입하여 독점적으로 소유하는 소중한 자산이며, 이들 모두에 관한 저작권 또한 브레인다이브에 귀속됩니다. 스마일보건 홈페이지에서 제공하는 모든 서비스, 자료, 정보들은 비상업적이고 개인적인 용도의 사용을 위하여만 제공되므로, 문자, 그림, 음성, 화상, 내려받기 파일, 링크 및 소스코드들 등 사이트에서 제공되는 서비스, 자료, 정보들(이하 "정보"라 칭합니다)을 상업적이거나 공공의 목적으로 내려 받거나 수정, 유통, 기타 어떠한 방식으로도 사용할 수 없습니다.</p>

<h2>[법적부인]</h2>
<p>스마일보건 홈페이지는 본 홈페이지 및 다른 관련 사이트들의 서비스와 정보들에 대한 정확도, 신뢰도, 완성도에 대해 보장하지 않으며, 스마일보건 홈페이지에서 제공하는 자료나 표현에는 오류가 있을 수 있음을 유념하시기 바랍니다. 따라서 고객 여러분은 저희가 서면으로 보장해 드리지 않는 한 이 정보나 자료들을 전적으로 의지하지는 마시기 바랍니다.</p>
<p>특히 스마일보건 홈페이지의 웹사이트 서비스를 활용해 개인이나 사업의 이익에 관여되는 판매, 무역, 구매 등의 거래에 직접적인 활용은 삼가 해 주시기를 바랍니다. 또한, 어떠한 경우에도 스마일보건 홈페이지는 이들 정보나 자료 등으로 인하여 발생하는 직접, 간접, 부수적, 특별 또는 확대 손해에 대해 책임지지 않음을 알려드립니다.</p>

<h2>[스마일보건 브랜드 도용 금지]</h2>
<p>스마일보건 브랜드(상호, 상표)는 원칙적으로 브레인다이브가 경영권을 소유한 「브레인다이브 계열사」 만이 사용할 수 있습니다. 현재 스마일보건 브랜드를 도용하는 업체에 대해서는 다음을 근거로 제재할 수 있습니다:</p>
<p class="indent">① 상법 제23조(주체를 오인시킬 상호의 사용금지)</p>
<p class="indent">② 상표법 제65조(권리침해에 대한 금지청구권)</p>
<p class="indent">③ 부정경쟁방지법 제4조 (부정경쟁행위의 금지청구권)</p>
<p>어떠한 경우라도 외부업체가 스마일보건 심볼(스마일보건 로고)을 쓰는 경우는 제재 대상이 되므로, 온라인/오프라인 상에서의 스마일보건 브랜드 오도용을 엄격히 규제합니다.</p>

<h2>[링크에 대한 책임]</h2>
<p>스마일보건 홈페이지는 여러분께 자체적인 기준에 의거해 다양한 링크를 제공하고 있습니다. 링크 된 웹사이트들은 모두 고객의 정보 획득과 편의를 위해 제공하고 있으나 링크 사이트에 대한 어떤 법적 책임도 스마일보건 홈페이지에 있지 않으며 웹사이트의 신뢰성에 대한 보장을 하지 않습니다.</p>

<h2>[고지사항의 변경]</h2>
<p>본 내용이 고지된 후에 스마일보건 홈페이지에서 제공하는 서비스를 이용하시는 모든 이용자는 본 고지내용에 동의하는 것으로 간주됩니다. 스마일보건 홈페이지는 본 고지사항에 명시된 세부항목과 사용조건의 변경이유를 홈페이지에 적절한 시간 여유를 가지고 고지하거나, 인터넷 산업의 상관례에 맞추어 적절한 방법으로 사전 통지 없이 수시로 변경할 권리와 권한을 가지고 있습니다.</p>

<div class="footer">
<p>이상의 법적고지는 2023년 10월 23일 부터 시행합니다.</p>
</div>
`,
  },
  4: {
    id: 4,
    title: "이메일무단수집거부",
    content: `
<h2>이메일무단수집거부</h2>
<p>본 홈페이지에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적인 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법에 의해 형사 처벌됨을 유념하시기 바랍니다.</p>

<div class="footer">
<p>[게시일 2023년 10월]</p>
</div>
`,
  },
};
